import React from 'react';
import StatsWidget from '@rio-cloud/rio-uikit/lib/es/StatsWidget';
import { DeviceTypeLabel } from '~/features/devices/components/DeviceType';
import DeliverableChip from '~/features/deliverables/components/DeliverableChip';
import { toShortSemanticVersion } from '~/features/base/utils/versionNumberConverter';
import { Campaign } from '~/api/models/campaign';
import { FormattedDate, FormattedMessage } from 'react-intl';
import CampaignStatusLabel from '../CampaignStatusLabel';

interface CampaignCardProps {
    campaign: Campaign;
    onClick: (campaign: Campaign) => void;
}

const CampaignCard: React.FC<CampaignCardProps> = ({ campaign, onClick }) => {


    return (
        <div className='col-4 margin-bottom-20' style={{ cursor: 'pointer' }}>
            <StatsWidget onClick={() => onClick(campaign)}>
                <StatsWidget.Body className='display-flex flex-column align-items-start gap-10 margin-top-15'>
                    <div className='display-flex justify-content-between width-100pct'>
                        <div className='text-size-16 title'>{campaign.name}</div>
                        <CampaignStatusLabel status={campaign?.status} />
                    </div>
                    <div className='display-flex align-items-center gap-5 margin-bottom-5'>
                        <span className='rioglyph rioglyph-calendar text-muted' aria-hidden='true' title='Creation Date'></span>
                        <span className='text-size-12 text-muted'>
                            <span>
                                <FormattedMessage id={'intl-msg:changeOperation.create'}/>: {campaign.creationDate ? (
                                    <FormattedDate
                                        value={new Date(campaign.creationDate)}
                                        year='numeric'
                                        month='short'
                                        day='2-digit'
                                    />
                                ) : 'N/A'}
                            </span>
                        </span>
                    </div>
                    <div className='display-flex'>
                        <DeviceTypeLabel deviceType={campaign.deviceType?.toUpperCase()}/>
                        <div
                            className='text-size-14'
                        >
                            <DeliverableChip
                                displayValue={`${campaign.deliverableId} @ ${toShortSemanticVersion(campaign.deliverableVersion)}`}
                                deliverableId={campaign.deliverableId}
                                deliverableType={campaign.deliverableType}
                                deliverableVersion={toShortSemanticVersion(campaign.deliverableVersion)}
                            />
                        </div>
                    </div>
                    <div className='display-flex flex-row align-items-baseline width-100pct'>
                        <div className='width-100pct'>
                            <div className='progress'>
                                <div
                                    className='progress-bar progress-bar-success'
                                    style={{ width: campaign.progress === 0 ? 0 : `10% ` }}
                                />
                            </div>
                        </div>
                        <div className='margin-left-5 text-size-14'>
                            {campaign.progress === 0 ? '0%' : `44%`}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </div>
    );
};

export default CampaignCard;
